const constructIdentifier = (
  key: string,
  id?: string | number | null,
): string => (id ? `${key}-${id}` : key);

export const saveLocalStorageValue = <T>({
  key,
  id,
  value,
}: {
  key: string;
  id?: string | number | null;
  value: T;
}): void => {
  const identifier = constructIdentifier(key, id);
  localStorage.setItem(identifier, JSON.stringify(value));
};

export const getLocalStorageValue = <T>({
  key,
  id,
  defaultValue,
}: {
  key: string;
  id?: string | number | null;
  defaultValue: T;
}): T => {
  const identifier = constructIdentifier(key, id);
  try {
    const value = localStorage.getItem(identifier);
    return value ? (JSON.parse(value) as T) : defaultValue;
  } catch (e) {
    localStorage.removeItem(identifier);
    return defaultValue;
  }
};
